import { render, staticRenderFns } from "./KatalogbestellungenLayout.vue?vue&type=template&id=1ed4a3a2&scoped=true"
import script from "./KatalogbestellungenLayout.vue?vue&type=script&lang=js"
export * from "./KatalogbestellungenLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed4a3a2",
  null
  
)

export default component.exports